import { reactive, toRef, watch } from "vue";
import {
	verkoopSchema,
	verplichtingenSchema,
} from "../schemas/klantgegevensSchema";
import { defineStore, storeToRefs } from "pinia";
import { useDossierDataStore } from "@/store/useDossierDataStore";

export default defineStore("klantgegevens", () => {
	const dossierDataStore = useDossierDataStore();
	const { data } = storeToRefs(dossierDataStore);

	const state = reactive({
		verplichtingenSchema: verplichtingenSchema,
		verkoopSchema: verkoopSchema,
		values: toRef(() => data.value.klantgegevens),
	});

	watch(
		() => data.value.klantgegevens,
		() => {
			data.value.klantgegevens ??= {};
		},
		{ immediate: true },
	);

	return {
		state,
	};
});
